export default __webpack_public_path__ + "media/we-offer-thumb.7f3a7081.jpg";